export default "/images/logo-md.png?95baf39fa8f122e9f51c62634ac55f9f";